<template lang="pug">
  div
    el-row.top20(:gutter="30")
      el-col(:lg="8", :md="8", :sm="24", v-if="mensagem.origem === 'CARTORIO'")
        span.negrito Cartório:&nbsp;
        span {{solicitacao.cartorio.nome}}
      el-col(:lg="8", :md="8", :sm="24")
        span.negrito Tipo da Mensagem:&nbsp;
        span {{TIPO_MENSAGEM[solicitacao.tipo]}}
    el-row.top20(:gutter="30")
      el-col(:lg="24", :md="24", :sm="24")
        span.negrito Despacho:&nbsp;
        div.top10(v-html="mensagem.despacho.replaceAll('$$BASE_URL_SISTEMA$$','#/visualizar')")
    el-row.top20()
      el-col(:lg="24", :md="24", :sm="24")
        span.negrito Anexos:
      el-col(:lg="24", :md="24", :sm="24")
        div.top10(v-if="mensagem.anexoCartorios.length === 0")
          span Sem anexos.
        .card(v-else)
          div
            el-table(
              :data="mensagem.anexoCartorios",
              style="width: 100%"
            )
              el-table-column(
                prop="nome",
                label="Anexo"
              )
              el-table-column(
                label="Download"
                prop="id"
                width="100"
                align="center"
              )
                template(slot-scope="scope")
                  span(@click="getDownload(scope.row)")
                    i.cursor.fas.fa-download
      el-col(:lg="24", :md="24", :sm="24", v-if=" ultima && aguardandoMinhaResposta(solicitacao) ")
        div.flex
          span Responda esta mensagem até {{solicitacao.prazo}}
      el-col(:lg="24", :md="24", :sm="24", v-if=" mensagem.dataVisualizacao ")
        div.flex
          span Visualizado {{mensagem.dataVisualizacao}}

</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import { TIPO_MENSAGEM } from '@/constants/cartoriosArrecadacao'

export default {
  data () {
    return {
      TIPO_MENSAGEM
    }
  },

  props: {
    mensagem: {
      type: Object,
      required: true
    },
    solicitacao: {
      type: Object,
      required: true
    },
    ultima: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    aguardandoMinhaResposta (solicitacao) {
      return solicitacao.status === 'AGUARDANDO_RESPOSTA_SICARF'
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  margin: 20px;
}
.card {
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5 !important;
}
.card-container {
  border: 1px solid #ebeef5 !important;
}
h1 {
  font-size: 35px !important;
}
.negrito {
  font-weight: bold;
}
.claro {
  color: rgb(182, 179, 179);
}
hr {
  display: block; height: 1px;
  border: 0; border-top: 1px solid rgb(182, 179, 179);
  margin: 1em 0; padding: 0;
}
.top20 {
  margin-top: 20px !important;
}
.top10 {
  margin-top: 10px !important;
}
.bottom30 {
  margin-bottom: 30px !important;
}
.fa-folder-download {
  color: #007DC6 !important;
  font-size: 25px !important;
  cursor: pointer;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.flex span {
  color: gray;
}
.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/VisualizarMensagem.vue